// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__v9kpU","upload":"Small_upload__3JiNk","imageWrap":"Small_imageWrap__298pY","removeBtn":"Small_removeBtn__3zSgD"};